import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var AddShippingAddressModal = function (_super) {
  __extends(AddShippingAddressModal, _super);

  function AddShippingAddressModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.modalVisible = false;
    _this.addressId = '';
    _this.addressForm = _this.generateInitForm();
    _this.countryList = [];
    _this.confirmLoading = false;
    _this.formDataRules = {
      name: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入联系人')
      }],
      phone: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入联系电话')
      }],
      countries_and_regions: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入国家/地区')
      }],
      province: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入省份')
      }],
      city: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入城市')
      }],
      detailedaddress: [{
        type: 'string',
        required: true,
        whitespace: true,
        message: _this.t('请输入详细地址')
      }]
    };
    return _this;
  }

  AddShippingAddressModal.prototype.generateInitForm = function () {
    return {
      name: '',
      phone: '',
      countries_and_regions: '',
      province: '',
      city: '',
      detailedaddress: ''
    };
  };

  AddShippingAddressModal.prototype.created = function () {
    this.queryCountryList();
  };

  AddShippingAddressModal.prototype.handleCancel = function () {
    var formModelRef = this.$refs.formModel;
    formModelRef.resetFields();
    this.addressForm = this.generateInitForm();
    this.modalVisible = false;
    this.addressId = undefined;
  };

  AddShippingAddressModal.prototype.queryCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryCountryList()];

          case 1:
            data = _a.sent().data;
            this.countryList = data;
            return [2];
        }
      });
    });
  };

  AddShippingAddressModal.prototype.handleOk = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formModelRef;

      var _this = this;

      return __generator(this, function (_a) {
        formModelRef = this.$refs.formModel;
        formModelRef.validate(function (valid) {
          return __awaiter(_this, void 0, Promise, function () {
            var postData, requestName, _a, code, message;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (!valid) {
                    return [2];
                  }

                  postData = Object.assign({}, this.addressForm);
                  requestName = '';

                  if (this.addressId) {
                    postData.id = this.addressId;
                    requestName = 'editShippingAddress';
                  } else {
                    requestName = 'addShippingAddress';
                  }

                  return [4, this.$api.warehouse[requestName](postData)];

                case 1:
                  _a = _b.sent(), code = _a.code, message = _a.message;

                  if (code === 0) {
                    this.modalVisible = false;
                    formModelRef.resetFields();
                    this.addressForm = this.generateInitForm();
                    this.$message.success(this.t('操作成功'));
                    this.$emit('success');
                    this.addressId = '';
                  } else {
                    this.$message.error(message);
                  }

                  return [2];
              }
            });
          });
        });
        return [2];
      });
    });
  };

  AddShippingAddressModal = __decorate([Component], AddShippingAddressModal);
  return AddShippingAddressModal;
}(Vue);

export default AddShippingAddressModal;